import { render, staticRenderFns } from "./VendorProfile.vue?vue&type=template&id=55620309"
import script from "./VendorProfile.vue?vue&type=script&lang=ts"
export * from "./VendorProfile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports